<div class="rv">
  <!-- The facts to check -->
  <section class="bk-panel rv__facts" aria-labelledby="rv-title">
    <div class="rv__head">
      <h2 class="bk-eyebrow" id="rv-title">Check before sending</h2>
      <button type="button" class="bk-btn bk-btn--ghost rv__edit" (click)="goBackToWriting()">
        <span class="bk-sym" aria-hidden="true">edit</span>
        Edit
      </button>
    </div>

    <dl class="bk-kv rv__kv">
      <dt>Subject</dt>
      <dd>{{ messageSubject }}</dd>

      <dt>Sender ID</dt>
      <dd>{{ senderID }}</dd>

      <dt>Recipients</dt>
      <dd aria-live="polite">
        @if (isFetchingCount && recipientCount === null) {
          <span class="bk-skel rv__skel" aria-hidden="true"></span>
          <span class="bk-sr-only">Counting recipients</span>
        } @else if (countError && recipientCount === null) {
          <span class="rv__quiet">{{ countError }}</span>
          <button type="button" class="rv__link" (click)="retryCount.emit()">Count again</button>
        } @else if (recipientCount !== null) {
          <span class="rv__big" [class.is-stale]="isFetchingCount">
            {{ countApprox ? "About " : "" }}{{ formatCount(recipientCount) }}
          </span>
          <span class="rv__quiet">{{ recipientCount === 1 ? "person" : "people" }}, each once</span>
        }
        @if (breakdown) {
          <span class="rv__line">From {{ breakdown }}.</span>
        }
        @if (countApprox) {
          <span class="rv__line">
            The numbers list is too long to check against your contacts here, so it is added as is.
          </span>
        }
      </dd>

      <dt>Message</dt>
      <dd>
        {{ partsLabel }}<span class="rv__sep" aria-hidden="true">·</span>{{ encodingLabel }}
        @if (parts.estimated) {
          <span class="rv__line">Personalised fields change the length for each contact, so the part count is an estimate.</span>
        }
      </dd>

      <dt>Estimated SMS</dt>
      <dd>
        @if (estimatedSms !== null) {
          <span class="rv__big" [class.is-stale]="isFetchingCount">{{ formatCount(estimatedSms) }}</span>
          <span class="rv__quiet">{{ partsLabel }} × recipients</span>
        } @else {
          <span class="rv__quiet">Shown once recipients are counted</span>
        }
      </dd>

      <dt>Delivery</dt>
      <dd>
        @if (scheduled && schedule && schedule.at) {
          {{ schedule.when }}
          <span class="rv__line">
            Goes out {{ schedule.countdown }}
            @if (schedule.local) {
              ({{ schedule.local }})
            }
          </span>
        } @else {
          As soon as you choose Send now
        }
      </dd>
    </dl>

    <div class="rv__test">
      <div class="rv__test-text">
        <p class="rv__test-title">Send a test first</p>
        <p class="rv__test-sub">Sends this message to one of your test contacts so you can read it on a real phone.</p>
      </div>
      <button type="button" class="bk-btn bk-btn--ghost" (click)="openTestMessageModal()">
        <span class="bk-sym" aria-hidden="true">science</span>
        Send a test
      </button>
    </div>
  </section>

  <!-- The message as it lands -->
  <section class="bk-panel rv__phone" aria-label="Message preview">
    <p class="rv__sender">
      <span class="rv__avatar" aria-hidden="true">{{ (senderID || "?").charAt(0) }}</span>
      <span class="rv__sender-name">{{ senderID }}</span>
    </p>
    <!-- The whole message: nothing is cut off on the step before sending. -->
    <bk-sms-bubble class="rv__bubble" variant="compact" [text]="messageBody" [clamp]="0" />
  </section>
</div>

<!-- MODALS -->
<app-send-test-message-modal
  [openModal]="showTestMessageModal"
  (closeModalEvent)="closeTestMessageModal()"
  [messageBody]="messageBody"
  [senderId]="senderID"
/>
